<template>
  <div style="width: 100%">
    <div class="my_labels">
      <label style="font-weight: normal;font-size: 13px;color: black">{{ label }}</label>
      <div>
        <el-button size="small" type="primary" link @click="dialogVisible = true"
        >{{ $t('common.edit') }}
        </el-button
        >
      </div>
    </div>
    <slot></slot>
  </div>
  <el-dialog
      v-model="dialogVisible"
      :title="title"
      width="600"
      draggable
      append-to-body
  >
    <div style="max-height: 400px;overflow: scroll;height: max-content">
      <el-form :model="form" label-position="left" ref="phoneForm">
        <el-form-item
            v-for="(item, index) in title.indexOf($t('common.contact.phone')) != -1
            ? form.phones
            : form.emails"
            :key="index"
            :label="label"
        >
          <template v-if="title.indexOf($t('common.contact.phone')) != -1">
            <el-input
                size="small"
                v-model="form.phones[index].phoneNumber"
                class="add_inputs"
            ></el-input>
          </template>
          <template v-else>
            <!--            <div style="position: relative;display: flex;flex-direction: column">-->
            <el-input
                size="small"
                v-model="form.emails[index].email"
                class="add_inputs"
                @input="handleCheckForm(form.emails[index])"
            ></el-input>
            <!--            {{form.emails[index]}}-->
            <span v-if="form.emails[index].emailMessage!==undefined"
                  :class="[form.emails[index].emailMessage==='ok'?'message_sp_inbox_email_ok':'message_sp_inbox_email']">
              {{ form.emails[index].emailMessage }}
            </span>
            <!--            </div>-->
          </template>
          <div
              class="setting_box"
              v-if="
              title.indexOf($t('common.contact.phone')) != -1
                ? form.phones.length > 1
                  ? true
                  : false
                : form.emails.length > 1
                ? true
                : false
            "
          >
            <!--                :icon="Remove"-->
            <el-button
                style="margin-left: 0px !important;"
                @click="removePhone(index,title.indexOf($t('common.contact.phone')) != -1?form.phones[index]:form.emails[index])"
                type="danger"
                link
            >
              {{ $t('common.delete') }}
            </el-button>
            <!--                :icon="Finished"-->
            <el-button
                style="margin-left: 0px !important;"
                v-if="!item.isDefault"
                @click="checkItem(index)"
                type="primary"
                link
            >{{ $t('common.set.main') }}
            </el-button
            >
          </div>
          <div v-else class="setting_box"></div>
        </el-form-item>
      </el-form>
      <div class="add_button">
        <el-button size="small" @click="addPhone" type="primary" :icon="Plus" text>{{ $t('common.add') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage} from "element-plus";
import {defineProps, ref, computed} from "vue";
import {useStore} from "vuex";
import {i18n} from "@/lang";
import {checkEmailAndWebsite} from "@/api/customer";
import {debounce, debouncePlus, isEmpty} from "@/utils/mylodash";
import {TIME_OUT} from "@/utils/statusParams";
import {Finished, Plus, Remove} from "@element-plus/icons-vue";
import sessionStore from "@/utils/sessionStore";

const store = useStore();
const {label, title} = defineProps({
  label: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
});

// 对话框
let dialogVisible = ref(false);
const form = computed(() => store.state.customer.form);

const addPhone = () => {
  console.log(title, 'title', title.indexOf(i18n.global.t('common.contact.phone')) !== -1)
  const targetArray = title.indexOf(i18n.global.t('common.contact.phone')) !== -1 ? "phones" : "emails";
  const targetKey = title.indexOf(i18n.global.t('common.contact.phone')) !== -1 ? "phoneNumber" : "email";
  console.log(form.value[targetArray]);
  // if (
  //     form.value[targetArray].filter((item) => item[targetKey] === "").length > 0
  // ) {
  //   ElMessage.error(i18n.global.t('system.input.add.text'));
  // } else {
  store.commit("customer/addEmailPhoneItem", {title});
  // }
};
const removePhone = (index, item) => {
  console.log(item, 'item')
  store.commit("customer/removeEmailPhoneItem", {index, title, item});
};

const checkItem = (selectedIndex) => {
  store.commit("customer/findSelectIndex", {selectedIndex, title});
};

const teamId = computed(() => store.state.email.teamID)
const email = ref("")
const handleCheckForm = debouncePlus(async (item) => {
  const payload = {
    teamId: teamId.value,
    email: item.email,
    customerId: sessionStore.get('customerId')
  }
  const res = await checkEmailAndWebsite(payload)
  console.log(res.result.email, 'res.result.email')
  // item.emailMessage = res.result.email
  if (!isEmpty(res.result) && res.result.email !== "ok" && res.result.email !== '' && item.email !== '') {
    ElMessage.warning(res.result.email)
  }
}, TIME_OUT)
</script>

<style lang="less" scoped>
.add_inputs {
  min-width: 120px;
}

.my_labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 30px;
  font-size: 13px;
  font-weight: normal !important;
}

:deep(.el-dialog) {
  min-width: 30% !important;
}

:deep(.el-form-item) {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  //margin-top: 16px !important;
}

:deep(.el-form-item__content) {
  align-items: center;
  flex-wrap: nowrap !important;
}

.setting_box {
  width: 160px;
  padding-left: 10px;
  display: block;
}

.add_button {
  //margin-top: 20px !important;
  display: flex;
  justify-content: flex-start;
  margin-left: 52px !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

:deep(.el-form-item__label) {
  font-size: 13px !important;
  font-weight: normal !important;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

.message_sp_inbox_email {
  position: absolute;
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  top: 20px !important;
  font-size: 12px !important;
  color: #e6a23c !important;
}

.message_sp_inbox_email_ok {
  position: absolute;
  width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  top: 20px !important;
  font-size: 12px !important;
  color: green !important;
}

:deep(.el-button.is-text:not(.is-disabled):hover) {
  background: transparent !important;
}

:deep(.el-icon) {
  font-size: 16px !important;
}
</style>
